module.exports = __webpack_public_path__ + "img/next-opp-logo-white.bf68fcc0.png";